import { forwardRef } from "react";
import { Flex, useFlexAlignment } from "../../layout";
import { mergeProps } from "../../shared";
import { useResponsiveValue } from "../../styling";
import { jsx as _jsx } from "react/jsx-runtime";
export function InnerGroup({
  align,
  as,
  children,
  forwardedRef,
  orientation,
  wrap,
  ...rest
}) {
  const alignValue = useResponsiveValue(align);
  const orientationValue = useResponsiveValue(orientation);
  const wrapValue = useResponsiveValue(wrap);
  const alignProps = useFlexAlignment({
    alignX: alignValue,
    alignY: "center",
    orientation: orientationValue
  });
  return /*#__PURE__*/_jsx(Flex, { ...mergeProps(rest, {
      as,
      ref: forwardedRef,
      wrap: wrapValue ? "wrap" : undefined
    }, alignProps),
    children: children
  });
}
export const Group = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerGroup, { ...props,
  forwardedRef: ref
}));